// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getVocabTypeById } from 'app/constants/enums/VocabType/main';

/* eslint-disable max-len */
export const COMPACT = getVocabTypeById('Compact');
export const SIMPLE = getVocabTypeById('Simple');
/* eslint-enable max-len */
